import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../../api/axiosInstance';
import axios from 'axios';
export const fetchOrderDetails = createAsyncThunk(
    'orderDetails/fetchOrderDetails',
    async ({ OrderId, token,language }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/Customer/GetRequestDetails?id=${OrderId}`, {
                headers: {
                    'accept': 'text/plain',
                    Authorization: `Bearer ${token}`,
                    "lang": language === "English" ? "2" : "1",

                },
            });
            if (response.status === 200) {
                // Parse the `message` field as JSON
                const parsedData = JSON.parse(response.data.message);
                return parsedData;
            } else {
                return rejectWithValue(response.data.errormessage);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const orderDetailsSlice = createSlice({
    name: 'orderDetails',
    initialState: {
        order: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrderDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOrderDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.order = action.payload;
            })
            .addCase(fetchOrderDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default orderDetailsSlice.reducer;
